import { ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Header } from 'shared/ui/header'

import s from './styles.module.scss'

interface Props {
  onGoBack: () => void
  title?: string
  subtitle?: string
  actionRight?: ReactNode
  onEditSearch?: () => void
}

export const ToursHeader = observer(
  ({ onGoBack, title, subtitle, actionRight, onEditSearch }: Props) => {
    const { t } = useTranslation()

    const BackButton = (
      <button
        type="button"
        aria-label={t('back')}
        onClick={onGoBack}
        className={s.iconButton}
      >
        <AppIcon
          width={24}
          height={24}
          className={s.icon}
          id={AllIcons.ARROW_LEFT}
        />
      </button>
    )

    const resolvedActionRight =
      actionRight ??
      (onEditSearch ? (
        <button
          type="button"
          aria-label={t('edit_search')}
          className={s.iconButton}
          onClick={onEditSearch}
        >
          <AppIcon
            width={20}
            height={20}
            className={s.editIcon}
            id={AllIcons.PENCIL}
          />
        </button>
      ) : undefined)

    const content = (
      <>
        <span className={clsx('bold-14', s.title)}>{title}</span>
        <span className={clsx('medium-12', s.subtitle)}>{subtitle}</span>
      </>
    )

    return (
      <div
        className={s.header}
        id={'share'}
      >
        <Header
          isFixed={true}
          actionLeft={BackButton}
          actionRight={resolvedActionRight}
        >
          {onEditSearch ? (
            <button
              type="button"
              className={clsx(s.content, s.contentButton)}
              onClick={onEditSearch}
            >
              {content}
            </button>
          ) : (
            <div className={s.content}>{content}</div>
          )}
        </Header>
      </div>
    )
  },
)
